import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CheckIcon from '@material-ui/icons/CheckCircle';
import React from 'react';
import EnhancedTableHead, { getSorting, HeadRow, Order, sortRows } from '../../../common/EnhancedTableHead';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import FaroDeckLink from '../../../faro/decks/FaroDeckLink';
import FaroDeploymentLink from '../../../faro/deployments/FaroDeploymentLink';

const useStyles = makeStyles(() =>
  createStyles({
    iconColumn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  })
);

interface Props {
  accountId: string;
  region: string;
  actions: any[];
}

const headRows: HeadRow[] = [
  { id: 'selected', disablePadding: false, label: 'Selected' },
  { id: 'actionName', disablePadding: false, label: 'Name' },
  { id: 'deckName', disablePadding: false, label: 'Deck' },
  { id: 'deploymentName', disablePadding: false, label: 'Deployment' },
  { id: 'version', disablePadding: false, label: 'Version' }
];

function ActionsTable(props: Props) {
  const { actions, accountId, region } = props;
  const classes = useStyles({});
  const [order, setOrder] = React.useState<Order>('desc');
  const [orderBy, setOrderBy] = React.useState<string>('selected');

  function handleRequestSort(event: React.MouseEvent<unknown>, property: string) {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
  }

  const sortedRows = sortRows(actions, getSorting(order, orderBy));

  return (
    <Table>
      <EnhancedTableHead
        order={order}
        orderBy={orderBy}
        fields={headRows}
        onRequestSort={handleRequestSort}
      />
      <TableBody>
        {sortedRows.map(row => (
          <TableRow key={row.actionName}>
            <TableCell>
              <div className={classes.iconColumn}>
                {row.selected && <CheckIcon color="primary" />}
              </div>
            </TableCell>
            <TableCell>{row.actionName}</TableCell>
            <TableCell>
              <FaroDeckLink
                deckName={row.deckName}
                version={row.version}
              />
            </TableCell>
            <TableCell>
              <FaroDeploymentLink
                deploymentName={row.deploymentName}
                accountId={accountId}
                region={region}
              />
            </TableCell>
            <TableCell>{row.version}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default ActionsTable;
